import i18n from '../i18n';

/**
 * Function to convert UTC time to date in the system's local time zone
 * @param {any} utcString - The UTC string to convert
 * @returns {any} - The date in the local time zone
 */
function UTCtDateoDateConvert(utcString: string): string {
  if (!utcString) {
    return '';
  }

  const date = new Date(utcString);

  if (Number.isNaN(date.getTime())) {
    return '';
  }

  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'UTC',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour12: false, // Not necessary for the date itself, but keeps it consistent
  };

  try {
    // Format the date to local time in the specified time zone
    const dateString = new Intl.DateTimeFormat(i18n.language, options).format(date);
    return dateString;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
}

export default UTCtDateoDateConvert;
